import content_article_list from './article-list';
import content_article_add from './article-add';
import content_article_edit from './article-edit';
import content_article_detail from './article-detail';
import content_article_history_detail from './article-history-detail';
import content_article_history_list from './article-history-list';

export default {
    content_article_list,
    content_article_add,
    content_article_edit,
    content_article_detail,
    content_article_history_detail,
    content_article_history_list,
};
